/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{width:100%;max-width:100%;max-height:90vh}img.big[_ngcontent-%COMP%]{cursor:zoom-out;height:100%}img.small[_ngcontent-%COMP%]{cursor:zoom-in;height:100vh}"];
export { styles as styles };
